import React, { useState } from 'react';
import styled, { keyframes } from 'styled-components';
import Swal from 'sweetalert2';
import api3000 from '../../services/api3000';

// Animação de entrada (fade + scale)
const fadeScaleIn = keyframes`
  0% { opacity: 0; transform: scale(0.7); }
  100% { opacity: 1; transform: scale(1); }
`;

const Overlay = styled.div`
  position: fixed;
  top: 0; left: 0;
  width: 100%; height: 100%;
  background: rgba(0,0,0,0.2);
  display: flex; justify-content: center; align-items: center;
  z-index: 1000;
`;

const Modal = styled.div`
  background: #fff;
  border-radius: 12px;
  padding: 25px 30px;
  width: 500px;
  max-width: 90%;
  animation: ${fadeScaleIn} 0.3s ease-out;
  box-shadow: 0 8px 20px rgba(0,0,0,0.25);
`;

const Title = styled.h2`
  margin-bottom: 20px;
  text-align: center;
`;

const Form = styled.form`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
`;

const Input = styled.input`
  padding: 10px;
  border: 1px solid #dcdcdc;
  border-radius: 6px;
  font-size: 14px;
  grid-column: span 2;

  &:focus {
    border-color: #3085d6;
    outline: none;
    box-shadow: 0 0 0 2px rgba(51, 153, 255, 0.2);
  }
`;

const Select = styled.select`
  padding: 10px;
  border: 1px solid #dcdcdc;
  border-radius: 6px;
  font-size: 14px;
  grid-column: span 2;

  &:focus {
    border-color: #3085d6;
    outline: none;
    box-shadow: 0 0 0 2px rgba(51, 153, 255, 0.2);
  }
`;

const ButtonRow = styled.div`
  grid-column: span 2;
  display: flex;
  justify-content: center;
  gap: 10px;
  margin-top: 20px;
`;

const Button = styled.button`
  padding: 10px 20px;
  border-radius: 6px;
  border: none;
  cursor: pointer;
  font-weight: bold;
  transition: all 0.2s ease;
  background: ${(props) => (props.primary ? '#3085d6' : '#dcdcdc')};
  color: ${(props) => (props.primary ? '#fff' : '#000')};

  &:hover { opacity: 0.9; transform: translateY(-1px); }
  &:active { transform: translateY(0); opacity: 0.8; }
`;

const UserFormCreate = ({ onClose, onCreated }) => {
  const [form, setForm] = useState({
    nome: '',
    email: '',
    senha: '',
    nivel_acesso: 'operador',
  });

  const handleChange = e => {
    const { name, value } = e.target;

    const limits = {
      nome: 100,
      email: 100,
      senha: 255
    };

    if (limits[name] && value.length > limits[name]) return;

    setForm({ ...form, [name]: value });
  };

  const handleSubmit = async e => {
    e.preventDefault();

    // Validações
    if (!form.nome || !form.email || !form.senha) {
      Swal.fire({ icon: 'error', title: 'Campos obrigatórios', text: 'Todos os campos são obrigatórios!' });
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(form.email)) {
      Swal.fire({ icon: 'error', title: 'E-mail inválido', text: 'Informe um e-mail válido!' });
      return;
    }

    if (form.senha.length < 8) {
      Swal.fire({ icon: 'error', title: 'Senha curta', text: 'A senha deve ter pelo menos 8 caracteres!' });
      return;
    }

    try {
      const token = localStorage.getItem('token');
      await api3000.post(
        '/api/users',
        { ...form },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      Swal.fire({ icon: 'success', title: 'Sucesso!', text: 'Usuário criado com sucesso!', showConfirmButton: false, timer: 1500 });
      onCreated();
      onClose();
    } catch (err) {
      Swal.fire({
        icon: 'error',
        title: 'Erro',
        text: err.response?.data?.message || err.message || 'Erro ao criar usuário'
      });
    }
  };

  return (
    <Overlay>
      <Modal>
        <Title>Criar Usuário</Title>
        <Form onSubmit={handleSubmit}>
          <Input 
            name="nome" 
            value={form.nome} 
            onChange={handleChange} 
            placeholder="Nome"
            maxLength={100}
          />

          <Input 
            name="email" 
            type="email" 
            value={form.email} 
            onChange={handleChange} 
            placeholder="Email"
            maxLength={100}
          />

          <Input 
            name="senha" 
            type="password" 
            value={form.senha} 
            onChange={handleChange} 
            placeholder="Senha (mín. 8 caracteres)"
            maxLength={255}
          />
          <Select name="nivel_acesso" value={form.nivel_acesso} onChange={handleChange}>
            <option value="operador">Operador</option>
            <option value="admin">Admin</option>
          </Select>
          <ButtonRow>
            <Button type="button" onClick={onClose}>Cancelar</Button>
            <Button type="submit" primary>Criar</Button>
          </ButtonRow>
        </Form>
      </Modal>
    </Overlay>
  );
};

export default UserFormCreate;
